module.exports = __webpack_public_path__ + "48115627f3190aee9d26443072d94d22.svg";